module.exports = __webpack_public_path__ + "static/3-fb005bc770deeb1303d08cb5ceb888da.jpeg";